import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Storage } from '@ionic/storage';

//types
import { UserInfo,ConfigInfo, LoginInfo } from '../model/types';
import { HttpResponse } from '@angular/common/http';
import { Response } from '@angular/http';
@Injectable()
export class AppSharedService {

   //class variable
  public userInfo:UserInfo;
  public configInfo:ConfigInfo;
  public selectedCategoryId:number;
  public selectedSubCategoryId:number;
  constructor(
              public storage: Storage
              ) {
this.selectedCategoryId=0;
this.selectedSubCategoryId=0;
this.setDefaultValue();
               }


  setDefaultValue(){

    this.configInfo={

      applicationInfo:{
        pathLargeImageUrl:"images/large",
        // apiBasePath:"https://test.bazaarhub.in",
         apiBasePath:"https://api.kuberdeals.com/",
        // apiBasePath:"http://localhost:52832/",
        cartStorageName:"bz_cart_01",
        currentAppVersion:1,
        fileBasePath:"https://adm.kuberdeals.com/",
        googlePackageName:"kuberdeals.ver01.margamindia",
        loginStorageName:"bz_user_01",
        minimumOrderAmount:0,
        offerTitle:"",
        pathMediumImageUrl:"images/medium",
        pathSmallImageUrl:"images/small",
        pathThumbnailImageUrl:"images/thumbnail",
      }
      ,
      urlInfo:{
        urlAddFMCToken:"/api/v2/common/addfmctoken/",
        urlAutocomplete:"/api/v2/getautocomplete/",
        urlCancelOrder:"/api/v2/account/cancelorder/",
        urlCheckOut:"/api/v2/account/checkout/",
        urlContactUs:"/api/v2/common/contact/",
        urlDeleteOrderDetails:"/api/v2/account/deleteorder/",
        urlGetAboutUs:"/api/v2/common/aboutus/",
        urlGetBannerList:"/api/v2/banner/",
        urlGetFilterType:"/api/v2/common/getfiltertype?LocationId=",
        urlGetLocationList:"/api/v2/common/getlocationlist/",
        urlGetOfferList:"/api/v2/offer/",
        urlGetOrderDetails:"/api/v2/account/orderdetails/",
        urlGetOrderHistory:"/api/v2/account/order/",
        urlGetProductDetails:"/api/v2/getproductdetails/",
        urlGetProductDetailsv2:"/api/v2/getproductdetailsnew/",
        urlGetProductForApp:"/api/v2/getproduct/",
        urlGetProductForAppv2:"/api/v2/getproduct/",
        urlGetProductUnitForAppv2:"/api/v2/getunitmaster/",
        urlGetProductUnitMappingForAppv2:"/api/v2/productunitmapping/",
        urlGetProductUnitAmountForAppv2:"/api/v2/product/",
        urlGetProfileDetails:"/api/v2/account/profile/",
        urlGetToken:"/api/v2/get/token/",
        urlLastShippingAddress:"/api/v2/account/address/",
        urlLogout:"/api/v2/common/logout?TokenId=",
        urlPlaceOrder:"api/v2/Account/Profile/urlPlaceOrder/",
        urlRegisterUser:"/api/v2/common/register/",
        urlUpdateProfileDetails:"/api/v2/account/profile/",
        urlUpdateLocation:"/api/v2/account/updatelocation/",
        urlWallet:"/api/v2/account/wallet/",
      }
    }
  }
  // get user information from storage
  getUserLoginInfo(){
    let loginInfo:LoginInfo=null;
    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {
      loginInfo= userinfo;
    });
    return loginInfo;
  }
  //clear storage variable
  clearUserLoginInfo(){
    this.storage.clear();
  }
  getHttpResponseMessage(responseobj:HttpResponse<any>,defmessage:string){
    
    var msg=defmessage;
    if(responseobj!=undefined && responseobj!=null && responseobj.body!=undefined && responseobj.body!=null){
     
      if(typeof responseobj.body === 'string' || responseobj.body instanceof String){
        msg=responseobj.body.toString();
      }
      else{
        if(responseobj.body.Message!=undefined && responseobj.body.Message!=null){
          msg=responseobj.body.Message.toString();
        }
      }
    }
    return msg;
  }
  getHttpResponseText(responseobj:Response,defmessage:string){
  
    var msg=defmessage;
    if(responseobj!=undefined && responseobj!=null){
      try{
        responseobj.json().then(function(data) { 
          if(typeof data === 'string' || data instanceof String){
            msg=data.toString();
          }
        }); 
      }
      catch{
        
      }
    }
    return msg;
  }
}


// WEBPACK FOOTER //
// ./src/pages/service/app_shared.ts